import type { AxiosInstance } from 'axios';

export interface OnlyOfficeConfig {
  document: {
    fileType: string;
    key: string;
    title: string;
    url: string;
    permissions: Record<string, boolean>;
  };
  editorConfig: {
    mode: string;
    callbackUrl: string;
    user: { id: string; name: string };
    lang: string;
    customization: Record<string, boolean>;
  };
  token?: string;
}

/**
 * Subject-type discriminator for `/v1/onlyoffice/editor-config`. Introduced
 * backend-side on 2026-04-21 — a fileId can exist as both a template
 * `source_file_id` AND an envelope-document file, so the caller must declare
 * which repository owns the fileId. Backend default is `TEMPLATE`; we only
 * pass `ENVELOPE` from envelope-scoped surfaces. See
 * `backend/contract-service/docs/api-endpoints.md` § GET /v1/onlyoffice/editor-config.
 */
export type EditorConfigFlow = 'TEMPLATE' | 'ENVELOPE';

export function createEditorService(client: AxiosInstance) {
  return {
    getEditorConfig: (
      fileId: string,
      mode: string = 'edit',
      flow: EditorConfigFlow = 'TEMPLATE',
    ) =>
      client
        .get<OnlyOfficeConfig>('/v1/onlyoffice/editor-config', {
          params: { fileId, mode, flow },
        })
        .then((r) => r.data),
  };
}
